export default __webpack_public_path__ + "static/media/i213jp.bbd007d5.webp";